import React from 'react';
import { Button, Col, ControlLabel, Form, FormControl, FormGroup, Panel } from 'react-bootstrap';
import NumberFormat from 'react-number-format';

const SignupForm = (props) => {

  const handleSubmit = async (event) => {
    event.preventDefault();
    const formData = new FormData(event.target);

    try {
      const response = await fetch(props.formUrl, {
        method: 'POST',
        body: formData
      });

      const result = await response.text();
      if (response.ok) {
        if (props.thankYouPageUrl) {
          window.location.href = props.thankYouPageUrl;
        } else {
          alert('Thank you! We will be following up with you within 1-2 business days.');
        }
      } else {
        alert('Please try submitting the form again.');
      }
    } catch (error) {
        alert('An error occurred. Please try again later.');
    }
  };
    
  return (
    <Panel bsStyle="info">
      <Panel.Heading>
        <Panel.Title componentClass="h2">Get a Copy of These Results and a Free Strategy Call</Panel.Title>
      </Panel.Heading>
      <Panel.Body>
        {/*WHEN CHANGING FORM FIELD NAMES, ALSO UPDATE IN RoiCalculatorController*/}
        <Form horizontal onSubmit={handleSubmit}>
          <FormGroup>
            <Col xs={12} sm={6} smOffset={3}>
              <ControlLabel>Email*</ControlLabel>
              <FormControl name="EMAIL_ADDRESS" type="text" required />
            </Col>
          </FormGroup>

          <FormGroup>
            <Col xs={12} sm={6} smOffset={3}>
              <ControlLabel>First Name</ControlLabel>
              <FormControl name="firstName" type="text" />
            </Col>
          </FormGroup>
          
          <input name="averageOrderValue" value={Math.round(props.averageOrderValue)} readOnly hidden />
          <input name="futureAverageOrderValue" value={Math.round(props.futureAverageOrderValue)} readOnly hidden />

          <input name="currentConversionRate" value={parseFloat(props.currentConversionRate.toFixed(2))} readOnly hidden />
          <input name="futureConversionRate" value={parseFloat(props.futureConversionRate.toFixed(2))} readOnly hidden />

          <input name="websiteSessionsMthly" value={Math.round(props.websiteSessionsMthly)} readOnly hidden />
          <input name="futureWebsiteSessionsMthly" value={Math.round(props.futureWebsiteSessionsMthly)} readOnly hidden />

          <input name="currentGPM" value={Math.round(props.currentGPM)} readOnly hidden />
          <input name="futureGPM" value={Math.round(props.futureGPM)} readOnly hidden />

          <input name="currentProfit" value={Math.round(props.currentProfit)} readOnly hidden />
          <input name="futureProfit" value={Math.round(props.futureProfit)} readOnly hidden />

          <input name="revenueOnline" value={Math.round(props.revenueOnline)} readOnly hidden />
          <input name="futureOnlineRevenue" value={Math.round(props.futureOnlineRevenue)} readOnly hidden />
          <input name="revenueTotal" value={props.revenueTotal} readOnly hidden />
          
          <input name="currentOnlineOrdersMthly" value={Math.round(props.currentOnlineOrdersMthly)} readOnly hidden />
          <input name="futureOnlineOrdersMthly" value={Math.round(props.futureOnlineOrdersMthly)} readOnly hidden />
          
          <FormGroup>
            <Col xs={8} xsOffset={2} sm={4} smOffset={3} className="text-xs-center">
              <Button type="submit" value="submit" bsStyle="primary" bsSize="large">Send Me My Copy</Button>
            </Col>
          </FormGroup>
        </Form>
      </Panel.Body>
    </Panel>
  );
};

export default SignupForm;